<template>
  <div>
    <logged-in-header />
    <totems-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import totemsPanel from "../components/totems/TotemPanel";

export default {
  components: {
    loggedInHeader,
    totemsPanel
  }
};
</script>
